import TransfersGrid from './TransfersGrid';

export default TransfersGrid;
